import Spinner from "@/components/Spinner";
import { Button } from "@/components/ui/button";
import { useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { pushModal } from "../../../store/slices/modalsSlice";
import GeneralMessageModal from "../../Modals/GeneralMessageModal";
import Qimg from "../QuestionBank/components/Qimg";
import { fetchQuestions } from "../QuestionBank/utils";

const FetchQuestionsInQuiz = ({ addQuestion, questionNum }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [questionsData, setQuestionsData] = useState(null);
  // const [teacherBankCats, setTeacherBankCats] = useState([]);
  const [chosenCat, setChosenCat] = useState(null);

  // useEffect(() => {
  //   handleGetBankCategories(setTeacherBankCats);
  // }, []);

  const { userProfileData } = useAppSelector((state) => state.store);

  const teacherBankCats = userProfileData?.bank_categories ?? [];

  const dispatch = useAppDispatch();

  const errorFn = () => {
    dispatch(pushModal(<GeneralMessageModal msg="حدث خطأ" btnMsg="حسنا" />));
  };

  return (
    <div className="p-3">
      <select
        className="w-full mb-3 p-2 border border-gray-300 rounded-lg bg-white"
        value={chosenCat}
        onChange={(e) => setChosenCat(e.target.value)}
        required
      >
        <option>إختر المجموعة</option>
        {teacherBankCats.map((ans) => (
          <option key={ans} value={ans}>
            {ans}
          </option>
        ))}
      </select>

      <Button
        type="button"
        className="w-full px-4 py-2"
        disabled={isLoading}
        onClick={(e) => {
          e.preventDefault();
          fetchQuestions({
            cat: chosenCat,
            setQuestionsData,
            setIsLoading,
            errorFn,
          });
        }}
      >
        {isLoading ? <Spinner variant="button" /> : "بحث"}
      </Button>

      <div className="my-2">
        {questionsData &&
          questionsData.map((question) => (
            <div
              key={question.id}
              className="clickable-question-card my-2 cursor-pointer border p-3 rounded-lg hover:bg-gray-100 transition"
              onClick={() => {
                addQuestion(question, questionNum);
                const imgBtn = document.getElementById(
                  `acc-btn-${questionNum}`
                );
                imgBtn?.click();
              }}
            >
              <Qimg
                paragraph={question.content}
                weight={question.weight}
                src={question.image_url}
                alt=""
              />
            </div>
          ))}
      </div>
    </div>
  );

  return (
    <div>
      <div className="p-3">
        <select
          className="form-select mb-3 rounded-lg"
          value={chosenCat}
          onChange={(e) => setChosenCat(e.target.value)}
          required
        >
          <option>إختر المجموعة</option>
          {teacherBankCats.map((ans) => (
            <option value={ans}>{ans}</option>
          ))}
        </select>
        {!isLoading && (
          <input
            type="submit"
            disabled={isLoading}
            className="ea-btn btn w-100 rounded-lg"
            value="بحث"
            onClick={(e) => {
              e.preventDefault();
              fetchQuestions({
                cat: chosenCat,
                setQuestionsData,
                setIsLoading,
                errorFn,
              });
            }}
          />
        )}
        {isLoading && (
          <button
            className="ea-btn btn w-100 rounded-lg"
            type="button"
            disabled
          >
            <span
              className="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            ></span>
            جاري البحث...
          </button>
        )}
      </div>
      <div className="my-2">
        {questionsData &&
          questionsData.map((question) => (
            <div
              className="clickable-question-card my-2"
              onClick={() => {
                addQuestion(question, questionNum);
                const imgBtn = document.getElementById(
                  `acc-btn-${questionNum}`
                );
                imgBtn.click();
              }}
            >
              <Qimg
                paragraph={question.content}
                weight={question.weight}
                src={question.image_url}
                alt={""}
              />
            </div>
          ))}
      </div>
    </div>
  );
};

export default FetchQuestionsInQuiz;
